import { Component, Fragment, h, Prop } from '@stencil/core';
import { Unsubscribe } from "@stencil/redux";
import { store } from "../../../redux/store";
import { RootState } from "../../../redux/reducers";
import {stepDescription, trans} from "../../../utils/trans";
import {Translations} from "../../../redux/types";

@Component({
    tag: 'rentware-step-description',
    styleUrl: 'style.sass',
    shadow: true,
})
export class RentwareStepDescription {
    @Prop({ mutable: true }) description: string;
    @Prop({ mutable: true }) translations: Translations;
    @Prop({ mutable: true }) locale: string;
    @Prop({ mutable: true }) id: string;
    unsubscribe!: Unsubscribe;

    componentWillLoad() {
        this.unsubscribe = store.mapStateToProps(this, (state: RootState) => {
            return {
                description: state.app.currentStep?.description,
                translations: state.system.translations,
                locale: state.app.locale,
                id: state.app.currentStep?.id,
            };
        });
    }

    disconnectedCallback() {
        this.unsubscribe();
    }

    get stepDescription(): string {
        return this.id &&
            trans(stepDescription(this.id), this.locale, this.translations) ||
            '';
    }

    render() {
        if (!!this.description) {
            return (
                <Fragment>
                    <rentware-spacer size="S" />

                    <div
                        class="MessageContainer"
                        innerHTML={this.stepDescription}
                    />

                    <rentware-spacer size="S" />
                </Fragment>
            );
        }

        return null;
    }
}
